<template>
    <a class="top-nav__link" href="/shop/cart/">
      <div class="top-nav__unit">
        <img class="top-nav__unit__cart" :src="logoCart" alt="logo cart">
        <div v-if="items" class="top-nav__unit__badge">{{ itemsStr }}</div>
      </div>
    </a>
</template>

 <script>
 import {mapGetters} from "vuex";
 import {getterTypes, actionTypes} from "@/store/modules/cart";

 export default {
   name: 'DashboardTopbarCart',
   data(){
     return {
       timeoutRefresh: 8000,
       logoCart: require('@/assets/svg/cart3.svg'),
     }
   },
   mounted() {
     this.getCart()
     this.getCartByInterval()
   },
   computed: {
    ...mapGetters({
      isLoading: getterTypes.isLoading,
      cart: getterTypes.cart,
    }),
    itemsStr(){
      let items = this.items
      if (items > 9){
        items = "9+"
      }
      return items
    },
    items(){
      let items = 0
      if (!this.cart){
        return items
      }
      this.cart.items.forEach((item) => {
        items = items + item.quantity
      })
      return items
    }
   },
   methods: {
     getCart(){
       this.$store.dispatch(actionTypes.getCart)
     },
     getCartByInterval(){
       setInterval(this.getCart, this.timeoutRefresh)
     }
   }
 }
 </script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";

  .top-nav{
    &__link{
      cursor: pointer;
    }
    &__unit{
      &__user{
        height: 22px;
        width: 22px;
        opacity: 80%;
      }
      &__cart{
        height: 22px;
        width: 22px;
        opacity: 80%;
      }
      &__badge{
        position: fixed;
        top: 44px;
        margin-left: 13px;
        background-color: $danger;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        line-height: 16px;
        text-align: center;
        color: white;
        font-size: 10px;
      }
    }
  }
</style>